import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoCdkPopoverDirective } from '@go-modules/directives/go-cdk-popover/go-cdk-popover.directive';
import { NgxSessionAttachmentsPopoverComponent } from '@go-modules/components/feedback-session/session-attachments-popover/session-attachments-popover.component';
import { SessionAttachmentsButtonComponent } from '@go-modules/components/session-attachments-button/session-attachments-button.component';
import {
	SessionAttachmentsWrapperDirective
} from 'go-modules/session-attachments/session-attachments-wrapper.directive';
import { MatTooltip } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoCdkPopoverDirective,
		SessionAttachmentsButtonComponent,
		SessionAttachmentsWrapperDirective,
		MatTooltip
	],
	declarations: [
		NgxSessionAttachmentsPopoverComponent
	],
	exports: [
		NgxSessionAttachmentsPopoverComponent
	]
})
export class SessionAttachmentsPopoverModule {}
